var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"商机流程设置"}},[_c('Flow')],1),_c('el-tab-pane',{attrs:{"label":"输单原因"}},[_c('Reason')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }